<div
    class="fixed bottom-[5vh] left-1/2 transform -translate-x-1/2 items-center flex"
>
    @switch (step) {
        @case (getInitialStep()) {
            <button
                mat-button
                mat-raised-button
                class="!bg-tertiary-50 !w-44 !h-[48px] !rounded-full"
                (click)="onButtonClick()"
            >
                <span class="my-auto !text-tertiary-900 text-nowrap"
                    >SEE HOW IT WORKS</span
                >
            </button>
        }
        @case (getLastStep()) {
            <button
                mat-button
                mat-raised-button
                class="!bg-tertiary-50 !w-44 !h-[48px] !rounded-full"
                (click)="onButtonClick()"
            >
                <span class="my-auto !text-tertiary-900">START</span>
            </button>
        }
        @default {
            <button
                mat-icon-button
                class="!bg-tertiary-50"
                (click)="onButtonClick()"
            >
                <mat-icon class="!text-tertiary-900"> chevron_right </mat-icon>
            </button>
        }
    }
</div>

@if (step !== getInitialStep()) {
    <div
        class="flex space-x-2 justify-center fixed bottom-[2vh] left-1/2 transform -translate-x-1/2"
        aria-label="Step indicators"
    >
        @for (index of stepRange; track index) {
            <span
                [class]="{ 'bg-tertiary-50': step === index }"
                [attr.aria-current]="step === index ? 'step' : null"
                class="outline outline-[0.15vh] outline-tertiary-50 h-[1vh] w-[1vh] rounded-full"
            ></span>
        }
    </div>
}
